<template>
  <div class="hilite-success">
    <div class="hilite-success-player">
      <slot></slot>
    </div>
    <div class="hilite-success-content">
      <div class="hilite-success-title" v-if="!video.title.length">
        <h3>Give your HiLite a title.</h3>
        <input id="title" name="Title" class="hilite-title" type="text" placeholder="Title" ref="title" />
      </div>
      <div class="hilite-success-share" v-else-if="video.title.length > 0">
        <h3>{{video.title}} is ready!</h3>
        <label>Share URL:</label>
        <br>
        <input id="share-url" name="URL" class="hilite-share-url" type="text" ref="shareURL" readonly :value="shareURL" />
        <br>
        <div class="share-button facebook">Share on <b>Facebook</b></div>
        <div class="share-button twitter">Share on <b>Twitter</b></div>
      </div>
      <footer class="editor-footer">
        <div class="primary button" v-if="!video.title.length" v-on:click="save">Save</div>
        <div class="primary button" v-else v-on:click="close">Close</div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "Success",
  props: ["video"],
  data: function() {
    return {
      shareURL: "http://www.hilitesports.com/example"
    }
  },
  methods: {
    save() {
      let that = this;
      this.video.title = this.$refs.title.value;
      this.$parent.$refs.editorPlayer.$refs.videoJSComponent.videoJSPlayer.trigger("getVideoThumbnail", function(thumbnail) {
        that.video.thumbnail = thumbnail;
      });
    },
    close() {
      this.$store.commit("addHiLite", this.video);
    }
  }
};
</script>

<style lang="stylus" scoped>
  .hilite-success
    display: flex
    flex-wrap: wrap
    .hilite-success-player
      flex-basis: 100%
    .hilite-success-title
      margin: auto
  .hilite-success-content
    width: 100%
    padding: 30px 40px
    display: flex
    flex-direction: column
    text-align: center
    h3
      margin: 0px 0px 20px 0px
    .hilite-title
      line-height: 40px
      font-family: "Hind"
      font-size: 24px
      padding: 0px 10px
  .editor-footer
    margin-top: auto
    padding: 0px
    .button
      margin-left: auto
  .hilite-share-url
    width: 100%
    max-width: 480px
    margin-bottom: 10px
    font-size: 14px
    text-align: center
  .share-button
    color: #FFF
    display: inline-block
    padding: 5px 20px
    border-radius: 10px
    margin-right: 10px
    cursor: pointer
    &:last-of-type
      margin-right: 0px
    &.facebook
      background: #4267B2
    &.twitter
      background: #1DA1F2
</style>
